import { render, staticRenderFns } from "./PoliticaPrivacidadeView.vue?vue&type=template&id=28290d4a&scoped=true&lang=true"
import script from "./PoliticaPrivacidadeView.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidadeView.vue?vue&type=script&lang=js"
import style0 from "./PoliticaPrivacidadeView.vue?vue&type=style&index=0&id=28290d4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28290d4a",
  null
  
)

export default component.exports